// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3uvZb","footer":"ModalUpdate_footer__2x-hY"};